var _rect, _rect2, _path, _rect3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMenuIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 17.5,
    height: 1.875,
    rx: 0.9375,
    transform: "matrix(-1 0 0 1 18.75 2.5)",
    fill: "black",
    fillOpacity: 0.65
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 11.25,
    height: 1.875,
    rx: 0.9375,
    transform: "matrix(-1 0 0 1 18.75 9.0625)",
    fill: "black",
    fillOpacity: 0.65
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.00529 8.09109C7.10018 7.9962 7.03919 7.83371 6.90529 7.82471L2.63075 7.53713C2.44178 7.52442 2.28503 7.68138 2.29801 7.87033L2.59116 12.1391C2.60035 12.2728 2.76271 12.3337 2.85753 12.2388L7.00529 8.09109Z",
    fill: "black",
    fillOpacity: 0.65
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 17.5,
    height: 1.875,
    rx: 0.9375,
    transform: "matrix(-1 0 0 1 18.75 15.625)",
    fill: "black",
    fillOpacity: 0.65
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuIcon);
export default __webpack_public_path__ + "static/media/menu-icon.02f91ecb.svg";
export { ForwardRef as ReactComponent };